export default __webpack_public_path__ + "static/media/icon-validacion.9efdac69.svg";